module.exports = __webpack_public_path__ + "img/male.80933a3a.svg";